import { MapPinnedIcon, MessagesSquareIcon, LayersIcon, BadgeCheckIcon } from 'lucide-react';
import type { Pillar } from '../types/content';

export const pillars: Pillar[] = [
  {
    title: 'Local Experience',
    description:
      'We work on Central Florida pools: screened lanais, strong sun, hard water, and the wear that comes with them.',
    icon: MapPinnedIcon,
  },
  {
    title: 'Clear Communication',
    description:
      "You'll know what we recommend, what it costs, and what to expect before any work begins.",
    icon: MessagesSquareIcon,
  },
  {
    title: 'Complete Pool Upgrades',
    description:
      'Surface, tile, coping, deck, and equipment handled by one team instead of several contractors.',
    icon: LayersIcon,
  },
  {
    title: 'Quality-Focused Work',
    description:
      'Careful prep and clean finishing, because that is what makes a renovation hold up over time.',
    icon: BadgeCheckIcon,
  },
];
